<template>
  <v-toolbar color="blue-grey lighten-5" class="index-topbar">
    <v-hover>
      <img slot-scope="{ hover }" src="../assets/logo-fine.png" alt="music x lab logo" class="logo" />
    </v-hover>
    <div class="logo-gap"></div>
    <template v-if="!$vuetify.breakpoint.smAndDown">
      <v-hover>
        <img slot-scope="{ hover }" src="../assets/logo-mbzuai.png" alt="mbzuai logo" class="logombz secondary-logo" />
      </v-hover>
      <div class="logo-gap"></div>
      <v-hover>
        <img slot-scope="{ hover }" src="../assets/logo-nyu.png" alt="nyu logo" class="logonyu secondary-logo" />
      </v-hover>
    </template>

    <v-spacer></v-spacer>

    <template v-if="!$vuetify.breakpoint.smAndDown">
      <v-toolbar-items style="font-family:'Breve Display';">
        <v-btn flat :color="active === 'home' ? $color.activate : $color.primary" style="font-size:1.2rem;font-weight:200;" @click="$router.push({ path:'/index' })">Home</v-btn>
        <v-btn flat :color="active === 'people' ? $color.activate : $color.primary" style="font-size:1.2rem;" @click="$router.push({ path:'/people' })">People</v-btn>
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn color="#575757" flat v-on="on" style="font-size:1.2rem;" @click="$router.push({ path:'/groups' })">Groups</v-btn>
          </template>
          <v-list>
            <v-list-tile v-for="(item, index) in groupInfo" :key="index" @click="$router.push({ name:'Groups', params:{ logan:item.logan } })">
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn color="#657C88" flat v-on="on" style="font-size:1.2rem;">Demos</v-btn>
          </template>
          <v-list>
            <v-list-tile v-for="(item, dindex) in demoInfo" :key="dindex" @click="$router.push({ path: item.address })">
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile flat @click="switchToPage('https://www.cs.cmu.edu/~gxia/demo.html')">
              <v-list-tile-title>Other Demos</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn flat :color="active === 'publications' ? $color.activate : $color.primary" style="font-size:1.2rem;" @click="$router.push({ path:'/publications' })">Publications</v-btn>
        <v-btn flat :color="$color.primary" style="font-size:1.2rem;" @click="switchToPage('http://blog.musicxlab.com/')">Blog</v-btn>
        <v-btn flat :color="$color.primary" style="font-size:1.2rem;" @click="switchToPage('https://github.com/music-x-lab/music-x-lab')">Github</v-btn>
      </v-toolbar-items>
    </template>

    <template v-else>
      <v-menu offset-y left content-class="navbar-menu-mobile">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" aria-label="Open navigation">
            <v-icon>menu</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile @click="$router.push({ path:'/index' })"><v-list-tile-title>Home</v-list-tile-title></v-list-tile>
          <v-list-tile @click="$router.push({ path:'/people' })"><v-list-tile-title>People</v-list-tile-title></v-list-tile>
          <v-list-tile @click="$router.push({ path:'/groups' })"><v-list-tile-title>Groups</v-list-tile-title></v-list-tile>
          <v-subheader v-if="demoInfo && demoInfo.length">Demos</v-subheader>
          <v-list-tile v-for="(item, dindex) in demoInfo" :key="'demo-'+dindex" @click="$router.push({ path: item.address })">
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="switchToPage('https://www.cs.cmu.edu/~gxia/demo.html')"><v-list-tile-title>Other Demos</v-list-tile-title></v-list-tile>
          <v-divider></v-divider>
          <v-list-tile @click="$router.push({ path:'/publications' })"><v-list-tile-title>Publications</v-list-tile-title></v-list-tile>
          <v-list-tile @click="switchToPage('http://blog.musicxlab.com/')"><v-list-tile-title>Blog</v-list-tile-title></v-list-tile>
          <v-list-tile @click="switchToPage('https://github.com/music-x-lab/music-x-lab')"><v-list-tile-title>Github</v-list-tile-title></v-list-tile>
          <v-divider></v-divider>
          <v-list-tile class="menu-logo-only">
            <img class="menu-logo-img" src="../assets/logo-mbzuai.png" alt="mbzuai logo">
          </v-list-tile>
          <v-list-tile class="menu-logo-only">
            <img class="menu-logo-img" src="../assets/logo-nyu.png" alt="nyu logo">
          </v-list-tile>
        </v-list>
      </v-menu>
    </template>
  </v-toolbar>
</template>

<script>
export default {
  name: 'NavBar',
  props: {
    groupInfo: {
      type: Array,
      default: () => []
    },
    demoInfo: {
      type: Array,
      default: () => []
    },
    active: {
      type: String,
      default: ''
    }
  },
  methods: {
    switchToPage(url) {
      window.location.href = url
    }
  }
}
</script>

<style scoped>
.logo-gap {
  width: 30px;
}
.secondary-logo {
  display: inline-block;
}
@media (max-width: 960px) {
  .secondary-logo {
    display: none;
  }
}
.menu-logo-only {
  min-height: 0;
  padding-top: 6px;
  padding-bottom: 6px;
}
.menu-logo-img {
  height: 28px;
  width: auto;
  display: block;
  margin: 0 auto;
  object-fit: contain;
}
.navbar-menu-mobile {
  left: auto !important;
  right: 8px !important;
}
</style>

